import { render, staticRenderFns } from "./ProjectTypeNewForm.vue?vue&type=template&id=9c544f1e"
import script from "./ProjectTypeNewForm.vue?vue&type=script&lang=js"
export * from "./ProjectTypeNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports